export default "__VITE_ASSET__V1Hk0VaA__"